module.exports = __webpack_public_path__ + "img/logo-full.73469e17.png";